module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1016-1feab531ee6b7dc6db59dd9c5522e35a.png";